import { useState } from "react";
import { auth } from "../firebase";
import CheckoutBrick from "./CheckoutBrick";
import { fetchCheckoutPlano } from "../utils/checkoutPlano";
import PlanCards from "./PlanCards";
import { usePrecos } from "../hooks/usePrecos";

const GERAR_URL    = "https://us-central1-matriz3dsite.cloudfunctions.net/gerarPreferencia";
const VALIDAR_URL  = "https://us-central1-matriz3dsite.cloudfunctions.net/validarCupom";

export default function PlanoExpirado({ uid, perfil, onLogout, onUpdate }) {
  const [assinando,    setAssinando]    = useState(null);
  const [erro,         setErro]         = useState("");
  const [preferenceId, setPreferenceId] = useState(null);
  const [checkoutId, setCheckoutId] = useState(null);
  const [planoBrick,   setPlanoBrick]   = useState(null);
  const [brickAmount,  setBrickAmount]  = useState(null);
  const [couponInput,  setCouponInput]  = useState("");
  const [cupomOk,      setCupomOk]      = useState(null);
  const [erroCupom,    setErroCupom]    = useState("");
  const [validandoCupom, setValidandoCupom] = useState(false);

  const precos = usePrecos();
  const expiredAt    = perfil?.expiredAt?.toDate?.()   || (perfil?.expiredAt   ? new Date(perfil.expiredAt)   : null);
  const trialEnds    = perfil?.trialEndsAt?.toDate?.() || (perfil?.trialEndsAt ? new Date(perfil.trialEndsAt) : null);
  const expiryDate   = expiredAt || trialEnds;
  const diasExpirado = expiryDate ? Math.floor((Date.now() - expiryDate) / 86400000) : 0;
  const diasParaExclusao = Math.max(0, 60 - diasExpirado);

  const aplicarCupom = async (plano) => {
    const code = couponInput.trim();
    if (!code) return;
    setValidandoCupom(true); setErroCupom(""); setCupomOk(null);
    try {
      const token = await auth.currentUser?.getIdToken(true);
      const res = await fetch(VALIDAR_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ code, plano: plano || "monthly" }),
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.error || "Cupom inválido");
      setCupomOk(d);
    } catch(e) { setErroCupom(e.message); }
    setValidandoCupom(false);
  };

  const assinar = async (plano) => {
    setAssinando(plano); setErro("");
    try {
      const token = await auth.currentUser?.getIdToken(true);
      const res = await fetchCheckoutPlano(GERAR_URL, {
        method:  "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body:    JSON.stringify({ plano, couponCode: cupomOk?.code || couponInput.trim() || null }),
      });
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(d.error || "Erro ao iniciar checkout");
      }
      const data = await res.json();
      setPlanoBrick(plano);
      setPreferenceId(data.preferenceId); setCheckoutId(data.checkoutId);
      setBrickAmount(data.amount || null);
    } catch(e) {
      setErro(e.message || "Erro ao abrir checkout. Tente novamente.");
    }
    setAssinando(null);
  };

  const handleSuccess = (plano) => {
    const expiresAt = new Date(Date.now() + (plano === "annual" ? 365 : 30) * 86400000);
    if (onUpdate) onUpdate(prev => ({ ...prev, plan: plano, planExpiresAt: expiresAt }));
    setPreferenceId(null);
  };

  return (
    <>
      <div style={{ position:"fixed", inset:0, background:"linear-gradient(160deg,#060b18 0%,#0a1628 60%,#071220 100%)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:9999, padding:24, overflowY:"auto" }}>
        <div style={{ maxWidth:640, width:"100%", background:"rgba(10,18,35,0.95)", border:"1px solid rgba(239,68,68,0.25)", borderRadius:20, padding:"40px 36px", boxShadow:"0 32px 80px rgba(0,0,0,0.7)", textAlign:"center", margin:"24px 0" }}>

          <div style={{ fontSize:48, marginBottom:16 }}>🔒</div>

          <h2 style={{ color:"#f1f5f9", fontWeight:900, fontSize:20, margin:"0 0 8px", letterSpacing:1 }}>
            Acesso suspenso
          </h2>
          <p style={{ color:"#64748b", fontSize:13, margin:"0 0 24px", lineHeight:1.6 }}>
            {perfil?.plan === "deleted"
              ? "Sua conta foi encerrada e os dados foram excluídos. Assine para criar uma nova conta."
              : `Seu período ${perfil?.plan === "trial" ? "de trial" : "de assinatura"} expirou. Assine para continuar usando o Print Control.`
            }
          </p>

          {diasParaExclusao > 0 && perfil?.plan !== "deleted" && (
            <div style={{ background:"rgba(239,68,68,0.07)", border:"1px solid rgba(239,68,68,0.2)", borderRadius:10, padding:"10px 16px", marginBottom:24 }}>
              <span style={{ color:"#fca5a5", fontSize:12, fontWeight:600 }}>
                ⚠️ Seus dados serão excluídos em <strong>{diasParaExclusao} dia{diasParaExclusao !== 1 ? "s" : ""}</strong> se você não assinar
              </span>
            </div>
          )}

          {/* jaUsouTrial={true} sempre: quem cai nesta tela já usou o trial (ou já foi
              assinante), então não faz sentido reoferecer o card de trial grátis aqui —
              só o plano pago, reaproveitando o mesmo componente usado em EscolherPlano/
              Configuracoes pra preço e regras não divergirem entre as telas. */}
          <div style={{ marginBottom:16, textAlign:"left" }}>
            <PlanCards precos={precos} jaUsouTrial={true} assinando={assinando} onAssinar={assinar} compact />
          </div>

          {/* Cupom */}
          <div style={{ background:"rgba(0,212,170,0.04)", border:"1px solid rgba(0,212,170,0.12)", borderRadius:10, padding:"12px 14px", marginBottom:12 }}>
            <div style={{ fontSize:10, fontWeight:700, color:"#64748b", marginBottom:7, letterSpacing:1 }}>CUPOM DE DESCONTO</div>
            <div style={{ display:"flex", gap:7 }}>
              <input
                value={couponInput}
                onChange={e => { setCouponInput(e.target.value.toUpperCase()); setCupomOk(null); setErroCupom(""); }}
                placeholder="Código de desconto"
                style={{ flex:1, padding:"7px 10px", background:"rgba(255,255,255,0.05)", border:"1px solid rgba(0,212,170,0.2)", borderRadius:7, color:"#f1f5f9", fontSize:11, fontFamily:"monospace", letterSpacing:2, outline:"none" }}
              />
              <button
                onClick={() => aplicarCupom(planoBrick || "monthly")}
                disabled={validandoCupom || !couponInput.trim()}
                style={{ padding:"7px 12px", background:"rgba(0,212,170,0.12)", border:"1px solid rgba(0,212,170,0.3)", color:"#00d4aa", borderRadius:7, fontSize:10, fontWeight:700, cursor:"pointer" }}
              >
                {validandoCupom ? "⏳" : "OK"}
              </button>
            </div>
            {cupomOk && <div style={{ marginTop:6, color:"#4ade80", fontSize:10, fontWeight:700 }}>✓ -R$ {cupomOk.discount?.toFixed(2)} · Total: R$ {cupomOk.finalAmount?.toFixed(2)}</div>}
            {erroCupom && <div style={{ marginTop:6, color:"#fca5a5", fontSize:10 }}>⚠️ {erroCupom}</div>}
          </div>

          <div style={{ fontSize:11, color:"#334155", textAlign:"center", marginBottom:16 }}>
            Reembolso garantido em até 7 dias
          </div>

          {erro && <p style={{ color:"#fca5a5", fontSize:12, marginBottom:12 }}>{erro}</p>}

          <button onClick={onLogout} style={{ background:"none", border:"none", color:"#475569", fontSize:12, cursor:"pointer", textDecoration:"underline" }}>
            Sair da conta
          </button>
        </div>
      </div>

      {preferenceId && (
        <CheckoutBrick
          preferenceId={preferenceId} checkoutId={checkoutId}
          plano={planoBrick}
          uid={uid}
          onSuccess={handleSuccess}
          onClose={() => { setPreferenceId(null); setPlanoBrick(null); setBrickAmount(null); }}
          amount={brickAmount}
          couponCode={cupomOk?.code || null}
        />
      )}
    </>
  );
}
